module.exports = __webpack_public_path__ + "img/D0019.5ad173a0.svg";